import { FC, useState, useEffect } from "react";
import { Grid } from "@mui/material";
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { ModalConfirm } from "../../components/common/ModalConfirm/ModalConfirm";
import { useNavigate } from "react-router-dom";
import { RoutesMap } from "../../types";
import { ApiStatus } from "../../types/api/status";
import { CustomBackdrop } from "../../components/common/CustomBackdrop/CustomBackdrop";
import { useCourseStore } from "../../hooks/useCourseStore";
import { Module, Theme } from "../../types/slices/coursesType";
import { BackButton } from "../../components/common/BackButton/BackButton";
import { CreateEditThemeWebModal } from "./components/CreateEditThemeWebModal";

const columns = [
  { type: "options", field: "options", label: "Opciones" },
  { type: "text", field: "name", label: "NOMBRE" },
];

const ThemesWeb: FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const [page, setPage] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(10);
  const [rowSelected, setRowSelected] = useState<Theme>({} as Theme);
  const [modalDeleteConfirm, setModalDeleteConfirm] = useState<boolean>(false);

  const {
    statusThemesWeb,
    themesWeb,
    selectedModule,
    openModal,
    getThemeWebByModule,
    setSelectedThemeWeb,
    deleteThemeWeb,
    setOpenModal,
    setEditThemeWeb,
    changeIsEdit,
    setSelectedModule,
  } = useCourseStore();

  useEffect(() => {
    if (selectedModule.id) {
      setLoading(true);
      getThemeWebByModule(selectedModule.id).then(() => setLoading(false));
    } else {
      navigate(RoutesMap.MODULES_OF_COURSES);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedModule]);

  const onAdd = () => {
    changeIsEdit(false);
    setOpenModal(true);
  };

  const onEdit = (rowSelected) => {
    changeIsEdit(true);
    setEditThemeWeb(rowSelected);
    setOpenModal(true);
  };

  const onDelete = (rowSelected) => {
    setRowSelected(rowSelected);
    setModalDeleteConfirm(true);
  };

  const onDeleteConfirm = async () => {
    const response = await deleteThemeWeb(rowSelected?.id || 0);
    if (response === true) {
      setSelectedThemeWeb({} as Theme);
      setModalDeleteConfirm(false);
      getThemeWebByModule(selectedModule.id);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const goBack = () => {
    setSelectedModule({} as Module);
    navigate(RoutesMap.MODULES_OF_COURSES);
  };

  return (
    <>
      {statusThemesWeb === ApiStatus.FETCHING && <CustomBackdrop open={true} />}
      <BackButton onClick={goBack} />
      <Grid item xs={12}>
        <CustomTable
          title={selectedModule ? "Temas del " + selectedModule.name + " - Web": "Temas - Web"}
          columns={columns}
          loading={loading}
          rows={themesWeb || []}
          onRowClick={() => {}}
          hasOptions
          onAddFn={onAdd}
          onDelete={onDelete}
          onEdit={onEdit}
          rowsPerPage={rowsPerPage}
          page={page}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Grid>
      {modalDeleteConfirm && (
        <ModalConfirm
          open={modalDeleteConfirm}
          closeModal={() => {
            setModalDeleteConfirm(false);
          }}
          onCancel={() => {
            setModalDeleteConfirm(false);
          }}
          onConfirm={onDeleteConfirm}
          status={statusThemesWeb}
        />
      )}
      {openModal && <CreateEditThemeWebModal />}
    </>
  );
};

export default ThemesWeb;
